// extracted by mini-css-extract-plugin
export default {"error":"YccNvg_FTg3h5b7h7Ny1","icon":"EkoCSIaOdly0PYwYeRXw","title":"tCWQPJPV0mfU8Enpgonk","description":"mvHUPctwYEnEzGG1JZje","pulse":"NXSB5bZdJR1gAVMTfbbQ"};